const Input = ({label, error, ...props}) => {
    return <div className="flex  mb-2 flex-col">
        {label && <label className={'text-sm mb-1'}>{label}</label>}
        <input {...props} className={`p-3 bg-gray-100  ${error ? 'focus:border-red-500' :'focus:border-green-500'} border-2 outline-none rounded-lg text-sm `} type="text"/>
        <p className={`text-sm h-3.5 text-red-500 ${error ? 'opacity-100':'opacity-0'}`}>{error}</p>
    </div>
}
export default Input